import moment from "moment";

function validateInput(value, nameofvalidation, extraValue) {
  //   input regex validations
  if (nameofvalidation == "EIN") {
    let isValidChange = false;
    if (typeof value === "string") {
      value = value.replace(/[^0-9|/]+/g, "");
    }
    let reg = /^\d{9}$/;
    isValidChange = reg.test(value);
    value = value.substring(0, 9);
    return { value: value, isValid: isValidChange };
  }
  else if (nameofvalidation == "ext") {
    // let isValidChange = false;
    value = value.replace(/[^0-9]+/g, '');
    //remove first space or zero
    value = value.replace(/^[\s]*/g, "");
    //remove consecutive space and space at last loaction
    value = value.replace(/\s+/g, " ");

    return { value: value, isValid: true };
  } else if (nameofvalidation == "address") {
    let isValidChange = false;
    value = value.replace(/^[\s|0]*/g, "");
    value = value.replace(/[`~!@$%^&*()_|+=?;:'"<>\{\}\[\]]/gi, "");
    isValidChange = value.length > 1;
    return { value: value, isValid: isValidChange };
  } else if (nameofvalidation == "addressLine2") {
    let isValidChange = false;
    value = value.replace(/^[\s|0]*/g, "");
    value = value.replace(/[`~!@$%^&*()_|+=?;:'"<>\{\}\[\]]/gi, "");
    if (value.length > 2) {
      isValidChange = true
    } else if (value.length == 0) {
      isValidChange = true
    } else {
      isValidChange = false
    }
    return { value: value, isValid: isValidChange };
  } else if (nameofvalidation == "traetingAddress") {
    let isValidChange = false;
    value = value.replace(/^[\s|0]*/g, "");
    value = value.replace(/[`~!@$%^&*()|<>\{\}\[\]]/gi, "");
    isValidChange = value.length > 1;
    return { value: value, isValid: isValidChange };
  } else if (nameofvalidation == "claimAddressLine1") {
    value = value.replace(/^[\s]*/g, "");
    //remove consecutive space and space at last loaction
    value = value.replace(/\s+/g, " ");
    let isValid = value.length > 2;
    return { value: value, isValid };
  } else if (nameofvalidation == "claimAddressLine2") {
    if (value.length > 0) {
      value = value.replace(/^[\s]*/g, "");
      value = value.replace(/\s+/g, " ");
      let isValid = value.length > 2
      return { value, isValid }
    } else {
      return { value: "", isValid: true }
    }
  } else if (nameofvalidation == "claimCity") {
    value = value.replace(/[^a-zA-Z ]+/g, '');
    //remove first space
    value = value.replace(/^[\s|0]*/g, "");
    //remove consecutive space and space at last loaction
    value = value.replace(/\s+/g, " ");
    let isValid = value.length > 2;
    return { value: value, isValid };
  } else if (nameofvalidation == "name" || nameofvalidation == "firstName" || nameofvalidation == "lastName") {
    let isValidChange = false;
    value = value.replace(/^[\s|0]*/g, "");
    value = value.replace(/\d/g, "");
    value = value.replace(/[`~!@#$%^&*()_|+=?;:,\\/"<>\{\}\[\]]/gi, "");
    if (value.length > 0) {
      isValidChange = value.length > 2;
    } else if (value.length == 0) {
      isValidChange = false;
    } else {
      isValidChange = true;
    }
    return { value: value, isValid: isValidChange };
  } else if (nameofvalidation == "claimName") {
    value = value.replace(/[^a-zA-Z ]+/g, '');
    //remove first space or zero
    value = value.replace(/^[\s|0]*/g, "");
    //remove consecutive space and space at last loaction
    value = value.replace(/\s+/g, " ");
    let isValid = value.length > 1;
    return { value: value, isValid };

  } else if (nameofvalidation == 'otherRef') {
    let isValid = value.trim().length > 2;
    return { value: value, isValid };
  } else if (nameofvalidation == 'subscriberName') {
    let isValidChange = false;
    value = value.replace(/^[\s|0]*/g, "");
    value = value.replace(/\d/g, "");
    value = value.replace(/[`~!@#$%^&*()|+=?;:,\\/"<>\{\}\[\]]/gi, "");

    if (value.length > 0) {
      isValidChange = value.length > 2;
    } else if (value.length == 0) {
      isValidChange = false;
    } else {
      isValidChange = true;
    }
    return { value: value, isValid: isValidChange };
  } else if (nameofvalidation == "email") {
    let isValidChange = false;

    let reg =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    isValidChange = reg.test(value);
    isValidChange = isValidChange && value.length > 1;
    return { value: value, isValid: isValidChange };
  } else if (nameofvalidation == "zipcode") {
    let isValidChange = false;
    value = value.replace(/[^0-9]+/g, "");
    //remove first space or zero
    value = value.replace(/^[\s]*/g, "");
    //remove consecutive space and space at last loaction
    value = value.replace(/\s+/g, " ");

    isValidChange = value.length == 5 || value.length == 6;
    if (Number(value) === 0) {
      isValidChange = false;
    }
    return { value: value.substring(0, 5), isValid: isValidChange };
  } else if (nameofvalidation == "faxnumber") {
    let isValidChange = false;
    let errorMsgOne = false;
    if (value[0] == 1) {
      errorMsgOne = true
    }
    if (typeof value === "string") {
      value = value.replace(/[^0-9]+/g, "");
      //removes 0 or space
      value = value.replace(/^[\s|0|1]*/g, "");
      //removes two or more consecutive spaces and space at last loaction
      value = value.replace(/\s+/g, " ");
    }
    var val1 = value.replace(/\D/g, "");
    var newVal1 = "";
    var sizes = [3, 3, 4];

    for (var y in sizes) {
      if (val1.length > sizes[y]) {
        newVal1 += val1.substr(0, sizes[y]) + "-";
        val1 = val1.substr(sizes[y]);
      } else break;
    }

    newVal1 += val1;
    value = newVal1;
    if (value.length == 12) {
      isValidChange = true;
    }
    return { value: value, isValid: isValidChange, errorMsg: errorMsgOne };
  } else if (nameofvalidation == "phoneNumber") {
    let errorMsgOne = false
    let isValidChange = false;
    if (value[0] == 1) {
      errorMsgOne = true
    }
    if (value.charAt(0) == "0" && value.charAt(1) == "0") {
      value = "0";
    }
    if (typeof value === "string") {
      value = value.replace(/[^0-9]+/g, "");
      //removes 0 or space
      value = value.replace(/^[\s|0|1]*/g, "");
      //removes two or more consecutive spaces and space at last loaction
      value = value.replace(/\s+/g, " ");
    }
    var val1 = value.replace(/\D/g, "");
    var newVal1 = "";
    var sizes = [3, 3, 4];

    for (var y in sizes) {
      if (val1.length > sizes[y]) {
        newVal1 += val1.substr(0, sizes[y]) + "-";
        val1 = val1.substr(sizes[y]);
      } else break;
    }

    newVal1 += val1;
    value = newVal1;
    if (value.length == 12) {
      isValidChange = true;
    }
    return { value: value, isValid: isValidChange, errorMsg: errorMsgOne };
  } else if (nameofvalidation == "city") {
    let isValidChange = false;
    if (typeof value === "string") {
      // value= value.replace(/^[\s|0]*/g,"");
      value = value.replace(/^[\s|0]*/g, "");
      value = value.replace(/\d/g, "");
      value = value.replace(/[`~!@#$%^&*()_|+=?;:,\\/"<>\{\}\[\]]/gi, "");
    }
    value = value.replace(/^[\s|0]*/g, "");
    if (value.length > 2) {
      isValidChange = true;
    } else if (value.length == 0) {
      isValidChange = false;
    }
    return { value: value, isValid: isValidChange };
  } else if (nameofvalidation == "state") {
    let isValidChange = false;
    if (value.length > 1) {
      isValidChange = true;
    } else if (value.length == 0) {
      isValidChange = false;
    }
    return { value: value, isValid: isValidChange };
  } else if (nameofvalidation == "password") {
    const regexPassword = new RegExp(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/);
    let isValidChange = regexPassword.test(value);
    return { value: value, isValid: isValidChange };
  }
  // Date of birth
  else if (nameofvalidation == "dob" || nameofvalidation == "guardianDOB" || nameofvalidation == "reports") {
    let isValidChange = false;

    // Current date 
    let today = new Date()
    let dd = today.getDate();
    let mm = today.getMonth() + 1; //January is 0!
    const yyyy = today.getFullYear();

    if (value.length > 9) {
      isValidChange = true;
    } else {
      isValidChange = false;
    }
    if (Number(value.substring(0, 4)) >= 1900 && (Number(value.substring(0, 4)) < yyyy)) {

      isValidChange = true;

    } else if ((Number(value.substring(0, 4)) == yyyy)) {
      if ((Number(value.substring(5, 7)) < mm)) {

        isValidChange = true;

      } else if ((Number(value.substring(5, 7)) == mm)) {

        if ((Number(value.substring(8, 10)) <= dd)) {
          isValidChange = true;
        } else {
          isValidChange = false;
        }

      } else {
        isValidChange = false;
      }

    } else {
      isValidChange = false;
    }
    if (nameofvalidation == "guardianDOB") {
      // let years = moment().diff(`${Number(value.substring(0, 4))}/${Number(value.substring(5, 7))}/${Number(value.substring(8, 10))}`, "years");
      // if (years < 18) {
      //   isValidChange = false;
      // } else {
      //   isValidChange = true;
      // }

      let birthDate = new Date(value);
      let currentDate = new Date();
      let date18YearsAgo = new Date();
      date18YearsAgo.setFullYear(currentDate.getFullYear() - 18);

      isValidChange = birthDate < date18YearsAgo
    } else if (nameofvalidation == "reports") {
      let userDate = new Date(value);
      let currentDate = new Date();
      let dateTwoYearsAgo = new Date();
      dateTwoYearsAgo.setFullYear(currentDate.getFullYear() - 2);
      dateTwoYearsAgo.setDate(currentDate.getDate() - 1)

      isValidChange = userDate >= dateTwoYearsAgo && userDate <= currentDate;
    }
    return { value: value, isValid: isValidChange }
  } else if (nameofvalidation == 'dateOfDiagnosis') {
    let isValidChange = false;
    // ${searchPatient.dob.value.substring(5, 7)}/${searchPatient.dob.value.substring(8, 10)}/${searchPatient.dob.value.substring(0, 4)}

    // Current date 
    let today = new Date()
    let dd = today.getDate();
    let mm = today.getMonth() + 1; //January is 0!
    const yyyy = today.getFullYear();

    let patientDateOfBirth = new Date(extraValue);
    let p_dd = patientDateOfBirth.getDate();
    let p_mm = patientDateOfBirth.getMonth() + 1;
    let p_YY = patientDateOfBirth.getFullYear();

    if (value.length > 9) {
      isValidChange = true;
    } else {
      isValidChange = false;
    }
    if (Number(value.substring(0, 4)) > p_YY && (Number(value.substring(0, 4)) < yyyy)) {

      isValidChange = true;

    } else if ((Number(value.substring(0, 4)) == p_YY)) {
      if ((Number(value.substring(5, 7)) > p_mm)) {

        isValidChange = true;

      } else if ((Number(value.substring(5, 7)) == p_mm)) {

        if ((Number(value.substring(8, 10)) >= p_dd)) {
          isValidChange = true;
        } else {
          isValidChange = false;
        }

      } else {
        isValidChange = false;
      }

    } else if ((Number(value.substring(0, 4)) == yyyy)) {
      if ((Number(value.substring(5, 7)) < mm)) {

        isValidChange = true;

      } else if ((Number(value.substring(5, 7)) == mm)) {

        if ((Number(value.substring(8, 10)) <= dd)) {
          isValidChange = true;
        } else {
          isValidChange = false;
        }

      } else {
        isValidChange = false;
      }

    } else {
      isValidChange = false;
    }
    return { value: value, isValid: isValidChange }
  }
  else if (nameofvalidation == 'dateOfDiagnosis_test') {
    let isValidChange = false;
    // ${searchPatient.dob.value.substring(5, 7)}/${searchPatient.dob.value.substring(8, 10)}/${searchPatient.dob.value.substring(0, 4)}

    // Current date 
    let today = new Date()
    let dd = today.getDate();
    let mm = today.getMonth() + 1; //January is 0!
    const yyyy = today.getFullYear();

    let patientDateOfBirth = new Date(extraValue);
    let p_dd = patientDateOfBirth.getDate();
    let p_mm = patientDateOfBirth.getMonth() + 1;
    let p_YY = patientDateOfBirth.getFullYear();

    if (value.length > 9) {
      isValidChange = true;
    } else {
      isValidChange = false;
    }
    if (Number(value.substring(0, 4)) > p_YY) {
      isValidChange = true;

    } else if ((Number(value.substring(0, 4)) == p_YY)) {
      if ((Number(value.substring(5, 7)) > p_mm)) {
        isValidChange = true;

      } else if ((Number(value.substring(5, 7)) == p_mm)) {
        if ((Number(value.substring(8, 10)) > p_dd)) {
          isValidChange = true;
        } else {

          isValidChange = false;
        }

      } else {

        isValidChange = false;
      }

    } else {
      isValidChange = false;
    }
    return { value: value, isValid: isValidChange }
  }
  // Social Security Number -SSN
  else if (nameofvalidation == "ssn") {
    let isValidChange = false;

    var val1 = value.replace(/\D/g, "");
    var newVal1 = "";
    var sizes = [3, 2, 4];

    for (var y in sizes) {
      if (val1.length > sizes[y]) {
        newVal1 += val1.substr(0, sizes[y]) + "-";
        val1 = val1.substr(sizes[y]);
      } else break;
    }

    newVal1 += val1;
    value = newVal1;

    var regexssn = new RegExp(/^[0-9]{9}$|^(?!123-45-6789|219-09-9999|078-05-1120|000-00-0000|111-11-1111|222-22-222|333-33-3333|444-44-4444|555-55-5555|666-66-6666|777-77-7777|888-88-8888|999-99-9999|012-34-5678|987-65-4321)(?!666|000|9\d{2})\d{3}-?(?!00)\d{2}-?(?!0000)\d{4}$/);
    isValidChange = regexssn.test(value)

    if (value.length < 11) {
      isValidChange = false;
    }
    return { value: value, isValid: isValidChange }
  }
  // Alien Number
  else if (nameofvalidation == "alienNumber") {
    let isValidChange = false;
    value = value.toUpperCase().replace(/[^aA0-9_]*$/g, "")

    var regexAln = new RegExp(/^A\d{7,9}$/)
    isValidChange = regexAln.test(value)
    if (
      value == 'a123456789' ||
      value == 'A123456789' ||
      value == 'a12345678' ||
      value == 'A12345678' ||
      value == 'a111111111' ||
      value == 'A111111111' ||
      value == 'a11111111' ||
      value == 'A11111111' ||
      value == 'a1111111' ||
      value == 'A1111111' ||
      value == 'a000000000' ||
      value == 'A000000000' ||
      value == 'a00000000' ||
      value == 'A00000000' ||
      value == 'a0000000' ||
      value == 'A0000000' ||
      value == '58535' ||
      value == 'CITIZEN' ||
      value == 'a999999999' ||
      value == 'A999999999' ||
      value == 'a99999999' ||
      value == 'A99999999' ||
      value == 'a9999999' ||
      value == 'A9999999' ||
      value == 'a888888888' ||
      value == 'A888888888' ||
      value == 'a88888888' ||
      value == 'A88888888' ||
      value == 'a8888888' ||
      value == 'A8888888' ||
      value == 'a777777777' ||
      value == 'A777777777' ||
      value == 'a77777777' ||
      value == 'A77777777' ||
      value == 'a7777777' ||
      value == 'A7777777' ||
      value == 'a666666666' ||
      value == 'A666666666' ||
      value == 'a66666666' ||
      value == 'A66666666' ||
      value == 'a6666666' ||
      value == 'A6666666' ||
      value == 'a555555555' ||
      value == 'A555555555' ||
      value == 'a55555555' ||
      value == 'A55555555' ||
      value == 'a5555555' ||
      value == 'A5555555' ||
      value == 'a444444444' ||
      value == 'A444444444' ||
      value == 'a44444444' ||
      value == 'A44444444' ||
      value == 'a4444444' ||
      value == 'A4444444' ||
      value == 'a333333333' ||
      value == 'A333333333' ||
      value == 'a33333333' ||
      value == 'A33333333' ||
      value == 'a3333333' ||
      value == 'A3333333' ||
      value == 'a222222222' ||
      value == 'A222222222' ||
      value == 'a22222222' ||
      value == 'A22222222' ||
      value == 'a2222222' ||
      value == 'A2222222' ||
      value == 'a987654321' ||
      value == 'A987654321' ||
      value == 'a98765432' ||
      value == 'A98765432' ||
      value == 'a9876543' ||
      value == 'A9876543' ||
      value == 'a876543210' ||
      value == 'A876543210' ||
      value == 'a87654321' ||
      value == 'A87654321' ||
      value == 'a8765432' ||
      value == 'A8765432' ||
      value == 'a7654321' ||
      value == 'A7654321' ||
      value == 'a76543210' ||
      value == 'A76543210' ||
      value == 'a012345678' ||
      value == 'A012345678' ||
      value == 'a01234567' ||
      value == 'A01234567' ||
      value == 'a0123456' ||
      value == 'A0123456' ||
      value == 'a1234567' ||
      value == 'A1234567' ||
      value == '22808' ||
      value == '58280'
    ) {
      isValidChange = false;
    }
    return { value: value, isValid: isValidChange }
  } else if (nameofvalidation == "dropDown") {
    return value != "" ? { value, isValid: true } : { value, isValid: false }
  } else if (nameofvalidation == "numberString") {
    value = value.replace(/[^0-9a-zA-Z_ ]*$/g, "").replace(/^[\s]*/g, "")
    let isValid = value.length > 2
    return { value, isValid }
  } else if (nameofvalidation == "numberStringGroupNumber") {
    value = value.replace(/[^0-9a-zA-Z_ ]*$/g, "").replace(/^[\s]*/g, "")
    let isValid = value.length > 2
    return { value, isValid:true }
  } else if (nameofvalidation == "addressLine2") {
    if (value.length > 0) {
      value = value.replace(/^[\s|0]*/g, "");
      value = value.replace(/[`~!@$%^&*()_|+=?;:'"<>\{\}\[\]]/gi, "");
      let isValid = value != "" ? true : false
      return { value, isValid }
    } else {
      return { value: "", isValid: true }
    }
  }

}
export default validateInput;
